export const scrollToFirstError = () => {
  setTimeout(() => {
   
    const fieldElement = document.getElementsByClassName(`field-required`)[0]
    if (fieldElement) {
      fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center'})
      return
    }

  }, 100)
}